import { transparentize } from 'polished';
import { TooltipSettings } from './types';

export const tooltipSettings: TooltipSettings = {
  componentVariants: {
    size: {
      prop: 'size',
      variants: {
        regular: {
          borderRadius: 1,
          paddingTop: 4,
          paddingRight: 5,
          paddingBottom: 4,
          paddingLeft: 5,
          maxWidth: '300px',
          boxShadow: (props: Record<string, any>) =>
            `0px 12px 24px ${transparentize(0.85, props.colors.black.dark)}`,
        },
      },
    },
    mode: {
      prop: 'mode',
      variants: {
        light: {
          backgroundColor: 'black.light',
          color: 'white.main',
          opacity: 0.9,
        },
        dark: {
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'white.dark',
          backgroundColor: 'white.main',
          color: 'black.light',
          opacity: 0.98,
        },
      },
    },
  },
};
